<template>
  <div style="width: 100%;height: 100%">
    <el-row type="flex" class="row-bg" justify="end">
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="自定义模板打印()"
        v-if="USE_PRINT_TEMPLATE == 1">
        打印预览
      </el-button>
      <template v-else>
        <template v-if="printStatus === 1 && companyID !== 100">
          <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="shortPreview(1)">
            短送货单打印(有备注)
          </el-button>
          <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="shortPreview(0)">
            短送货单打印(无备注)
          </el-button>
          <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="preview(1)">
            送货数量打印
          </el-button>
          <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="preview(0)">
            打印预览
          </el-button>
          <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="previewCustom">
            打印预览(客户编码)
          </el-button>
        </template>
        <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="previewSpecial"
          v-show="printStatus === 1">
          打印五联单
        </el-button>
      </template>
    </el-row>
    <!-- 订单Title -->
    <V-DSOrderDetailTitleData :title-data="data[0]"></V-DSOrderDetailTitleData>
    <el-button style="display: inline-block; margin-bottom: 20px;" size="small" @click="secondConvert"
      v-if="isConverted">
      二次转换
    </el-button>
    <el-button style="display: inline-block; margin-bottom: 20px;" icon="el-icon-thumb" size="small" v-if="!isConverted"
      @click="manualConversion">
      手动转换
    </el-button>
    <el-button style="display: inline-block; margin-bottom: 20px;" icon="el-icon-finished" size="small"
      v-if="!isConverted" @click="manualChangeOrderStatusToConversion">
      手动修改订单状态为已转换
    </el-button>
    <el-row>
      <el-col :span="24">
        <el-form :model="tableForm" ref="tableForm" :rules="tableRules">
          <el-table :data="tableForm.tableData" border stripe style="width: 100%"
            @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column type="index" label="序号" width="45"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="名称" min-width="100"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
            <el-table-column prop="NEED_COUNT" label="送货数量">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData[${scope.$index}].NEED_COUNT`" :rules="tableRules.NEED_COUNT"
                  style="margin: 22px 0;" v-if="canAccept">
                  <el-input v-model="scope.row.NEED_COUNT"></el-input>
                </el-form-item>
                <span v-else>{{ scope.row.NEED_COUNT }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="NEW_REAL_COUNT" label="实收数量">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData[${scope.$index}].NEW_REAL_COUNT`" :rules="tableRules.NEW_REAL_COUNT"
                  style="margin: 22px 0;" v-if="canAccept">
                  <el-input v-model="scope.row.NEW_REAL_COUNT"></el-input>
                </el-form-item>
                <span v-else>{{ scope.row.REAL_COUNT }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="SUPPLIER_TOTAL_FEE" label="总价（元）"></el-table-column>
            <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
            <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
            <el-table-column label="操作" width="200" v-if="canEdit">
              <template slot-scope="scope">
                <el-button type="text" @click="openEdit(scope.row)">修改</el-button>
                <el-button type="text" @click="openAllEdit(scope.row)">修改全部</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row class="buttonGroup" v-if="canAccept">
      <el-button size="small" @click="__confirm" type="primary">确认订单</el-button>
      <el-button size="small" @click="confirmWithNeedCount" type="primary">一键验收为送货数量</el-button>
      <el-button size="small" @click="updateSend">修改为送货数量</el-button>
      <el-button size="small" @click="batchUpdateSendCont" type="primary">批量修改送货数量</el-button>
      <el-button size="small" @click="updateOrder">修改为订购数量</el-button>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="statusFlag" finish-status="success" v-show="statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <el-dialog title="二次转换产品信息" center :visible.sync="secondConvertVisible" width="600px">
      <el-table :data="secondConvertProductTable" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="45"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column label="供应商">

          <template slot-scope="scope">
            <el-select v-model="scope.row.SUPPLIER_ID" filterable>
              <el-option v-for="item in thirdSupplierList" :label="item.NAME" :value="item.ID" :key="item.ID">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="单价（元）">

          <template slot-scope="scope">
            <el-input v-model="scope.row.PRICE"
              @change="(value) => { if (!checkPrice(value)) { $message.show({ text: '请输入正确的价格', type: 'warning' }) } }"
              oninput="value=value.replace(/[^\d{1,}\.{,1}\d{1,}|\d{1,}]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <tooltip-button :disabled="secondConvertCompleted" tipContent="请为所有要转换的产品选择供应商并填写正确的价格" buttonType="primary"
          buttonText="确 定" buttonSize="small" @click="submitSecondConvert">
        </tooltip-button>
      </div>
    </el-dialog>
    <el-dialog title="手动转换" center :visible.sync="convertFormVisible" width="600px">
      <el-table :data="manualConvertProductTable" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="45"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column label="供应商">

          <template slot-scope="scope">
            <el-select v-model="scope.row.SUPPLIER_ID" filterable>
              <el-option v-for="item in thirdSupplierList" :label="item.NAME" :value="item.ID" :key="item.ID">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="单价（元）">

          <template slot-scope="scope">
            <el-input v-model="scope.row.PRICE"
              @change="(value) => { if (!validation.价格正数验证(value)) { $message.show({ text: '请输入正确的价格', type: 'warning' }) } }">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <tooltip-button :disabled="manualConvertCompleted" tipContent="请为所有要转换的产品选择供应商并填写正确的价格" buttonType="primary"
          buttonText="确 定" @click="submitmanualConversion">
        </tooltip-button>
      </div>
    </el-dialog>

    <el-dialog title="错误信息" center :visible.sync="已经转换产品模态框" width="600px">
      <el-table :data="错误的产品列表" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="45"></el-table-column>

        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="ERROR" label="错误原因" min-width="300"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="关闭已经转换产品模态框()">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
      <el-form :model="editForm" ref="editForm" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ name }}</span>
        </el-form-item>
        <el-form-item label="送货数量：">
          <el-input v-model="editForm.NEED_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitEdit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改全部信息 -->
    <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="600px">
      <el-form :model="editAllForm" ref="editAllForm" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ Editname }}</span>
        </el-form-item>
        <el-form-item label="采购价：">
          <el-input v-model="editAllForm.BUY_PRICE" @change="countPrice" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="报损后单价：">
          <span> {{ editAllForm.WPRICE }}</span>
        </el-form-item>
        <el-form-item label="销售价：">
          <el-input v-model="editAllForm.REAL_PRICE" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：">
          <el-input v-model="editAllForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="editAllForm.PRODUCT_COMMENT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="submitEditAll" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!--表格弹出框   下列为实收数量与订购数量不一致的产品，请再次确认-->
    <el-dialog title="提示" :visible.sync="tableVisible" width="40%" center>
      <p style="color: red; text-align: center">下列为单价或数量有变动的产品，请再次确认</p>
      <el-table :data="changeProducts" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
        <el-table-column prop="PRICE" label="单价" min-width="60"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
        <el-table-column prop="COUNT" label="订购数量" min-width="80"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTable()">取 消</el-button>
        <el-button size="small" type="primary" @click="subDataToServer()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  confirmOrderFun,
  notOrderDetailFun, priceCountFun, updateBookFun, updateNewDetailFun_Limit, updateOrderFun, updateSendFun, updateZLFun,
} from 'api/sellOrder';

import { getActionFun } from 'api/login';
import bus from '@/assets/common/bus';
import http from '@/assets/common/http';
import VDSOrderDetailTitleData from '../DSOrder/DSOrderDetailTitleData';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      PAGE_ID: '1000501', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100050101: 0, 100050102: 0 },
      fromName: ['sellOrderFivePrint', 'printPreviewCustom', 'sellOrderPrint', 'sellOrderCustomPrintDetail', 'toBeConfirmePrintDetail', 'supplierSendOrder'],
      toName: ['sellOrderFivePrint', 'printPreviewCustom', 'sellOrderPrint', 'sellOrderCustomPrintDetail', 'toBeConfirmePrintDetail'],
      managername: sessionStorage.getItem('name'),
      tableForm: {
        tableData: [],
      },
      错误的产品列表: [],
      name: '',
      data: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      printStatus: '',
      formLabelWidth: '100px',
      已经转换产品模态框: false,
      editForm: {},
      editFormVisible: false,
      addForm: {},
      companyID: Number(sessionStorage.getItem('tcId')),
      ORDER_ID: sessionStorage.getItem('orderId'),
      ORDER_DETAIL_ID: '',
      checkData: [],
      statusFlag: 0,
      editAllForm: {},
      Editname: '',
      addPoint: 0,
      firstFormadd: {},
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      isisdisabled: false,
      isConverted: Boolean(Number(sessionStorage.getItem('isConverted'))),
      checkedList: [],
      manualConvertProductTable: [],
      secondConvertVisible: false,
      convertFormVisible: false,
      secondConvertProductTable: [],
      thirdSupplierList: JSON.parse(sessionStorage.getItem('thirdSupplierList')) || [],
      USE_PRINT_TEMPLATE: 0,
      订单状态: 0,
      tableRules: {
        NEW_REAL_COUNT: [
          { required: true, message: '请输入实收数量', trigger: 'blur' },
          {
            validator: (rule, value, cb) => {
              if (this.$util.JudgmentUnit(this.tableForm.tableData[rule.field.match(/\[(\d+)\]/)[1]].TYPE_UNIT) ? !validation.数量正数0验证(value) : !validation.数量整数正数0验证(value)) cb('请输入正确的实收数量');
              cb();
            },
            trigger: 'blur',
          },
        ],
        NEED_COUNT: [
          { required: true, message: '请输入送货数量', trigger: 'blur' },
          {
            validator: (rule, value, cb) => {
              if (this.$util.JudgmentUnit(this.tableForm.tableData[rule.field.match(/\[(\d+)\]/)[1]].TYPE_UNIT) ? !validation.数量正数0验证(value) : !validation.数量整数正数0验证(value)) cb('请输入正确的送货数量');
              cb();
            },
            trigger: 'blur',
          },
        ],
      },
      loading: false,
      editAllFormVisible: false,
      tcStatus: sessionStorage.getItem('TC_STATUS'),
      tableVisible: false,
      changeProducts: [],
    };
  },
  components: {
    VDSOrderDetailTitleData,
  },
  computed: {

    secondConvertCompleted () {
      for (const item of this.secondConvertProductTable) {
        if (!item.SUPPLIER_ID || !validation.价格正数验证(item.PRICE.toString())) {
          return false;
        }
      }
      return true;
    },
    manualConvertCompleted () {
      for (const item of this.manualConvertProductTable) {
        if (!item.SUPPLIER_ID || !validation.价格正数验证(item.PRICE.toString())) {
          return false;
        }
      }
      return true;
    },
    canAccept () {
      return this.fun_dic[100050101] && this.isConverted && [3, 4].includes(this.data[0].STATUS) && this.tcStatus == 2;
    },
    canEdit () {
      return this.fun_dic[100050102] && this.isConverted && [3, 4].includes(this.data[0].STATUS) && this.tcStatus == 2;
    },
  },
  methods: {
    关闭已经转换产品模态框 () {
      this.错误的产品列表 = [];
      this.已经转换产品模态框 = false;
    },
    // 是否使用模板
    queryForm () {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID: this.companyID,
      };
      http.post(params).then((result) => {
        this.USE_PRINT_TEMPLATE = result[0].USE_PRINT_TEMPLATE;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------查看订单详情
    queryOrderDetailListData () {
      const params = {
        ID: Number(this.ORDER_ID),
        FILTER_FLAG: 0,
        GYS_ID: sessionStorage.getItem('tcId'),
        Supplier_Third_Type: 1,
      };
      notOrderDetailFun(params).then((result) => {
        this.tableForm.tableData = result.length > 0 ? result[0].DETAIL.map((item) => Object.assign(item, {
          NEED_COUNT: item.NEED_COUNT < 0 ? item.PRODUCT_COUNT : item.NEED_COUNT,

          PRICE: item.REAL_PRICE,
          NEW_REAL_COUNT: item.REAL_COUNT,
        })) : [];
        this.data = result.length > 0 ? result[0].TITLE.map((item) => ({
          ...item,
          ORDER_ID: item.ID,
          ORDER_CODE: item.ORDER_CODE,
          SEND_DATE: item.SEND_DAY,
          TOTAL_FEE: item.REAL_TOTAL_SUPPLIER_FEE,
          SUPPLIER_NAME: item.SUPPLIER_NAME,
          CUSTOMER_NAME: item.CUSTOM_NAME,
          PROJECT_NAME: item.PROJECT_NAME,
          DK_NAME: item.DK_NAME,
        })) : [];
        this.订单状态 = result[0].TITLE[0].STATUS;
        this.checkData = result.length > 0 ? result[0].OR[0].DATA : [];
        this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
        this.printStatus = result[0].PRINT_FLAG;
        // ---------------------------------------获取判断的companyID
        this.companyID = result[0].TITLE[0].TC_ID;
        this.addPoint = result[0].TITLE[0].ADD_POINT;
        this.queryForm();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    自定义模板打印 () {
      sessionStorage.setItem('TEM_TCID', this.companyID);
      if ([6, 7, 8, 9].includes(this.订单状态)) {
        this.$router.push({ name: 'toBeConfirmePrintDetail', params: { isThirdParty: 1 } });
      } else {
        this.$router.push({ name: 'sellOrderCustomPrintDetail', params: { isThirdParty: 1 } });
      }
    },
    preview (flag) {
      this.$router.push({ name: 'sellOrderPrint', params: { isThirdParty: 1 } });
      sessionStorage.setItem('countFlag', flag);// 0表示打印订购数量,1表示打印送货数量
      sessionStorage.setItem('isShortDocFlag', 0);
      sessionStorage.setItem('printRealFlag', 0);
    },
    shortPreview (num) {
      this.$router.push({ name: 'sellOrderPrint', params: { remarks: num, isThirdParty: 1 } });
      sessionStorage.setItem('countFlag', 1);
      sessionStorage.setItem('isShortDocFlag', 1);
      sessionStorage.setItem('printRealFlag', 0);
    },
    previewCustom () {
      this.$router.push({ name: 'printPreviewCustom', params: { isThirdParty: 1 } });
      sessionStorage.setItem('sendFlag', 0);
    },
    close () {
      this.convertFormVisible = false;
      this.queryOrderDetailListData();
    },
    closeAll () {
      this.secondConvertVisible = false;
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 平昌的特殊形式打印
    previewSpecial () {
      this.$router.push({ name: 'sellOrderFivePrint', params: { isThirdParty: 1 } });
    },
    handleSelectionChange (val) {
      this.checkedList = [...val];
    },
    secondConvert () {
      if (!this.checkedList[0]) {
        this.$message.show({ text: '请先选择要转换的产品', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 10,
        ORDER_ID: this.ORDER_ID,
        ORDER_DETAIL_ID_LIST: this.checkedList.map((item) => item.ORDER_DETAIL_ID),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      http.post(params).then((res) => {
        this.secondConvertVisible = true;
        this.secondConvertProductTable = res.map((item) => ({
          ...item,
          SUPPLIER_ID: item.SUPPLIER_ID || '',
        }));
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 手动修改订单状态为已转换
    manualChangeOrderStatusToConversion () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 113,
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '手动修改订单状态为已转换成功', type: 'success' });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 手动转换 模态框
    manualConversion () {
      if (!this.checkedList[0]) {
        this.$message.show({ text: '请先选择要转换的产品', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 10,
        ORDER_ID: Number(this.ORDER_ID),
        ORDER_DETAIL_ID_LIST: this.checkedList.map((item) => item.ORDER_DETAIL_ID),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      http.post(params).then((res) => {
        this.convertFormVisible = true;
        this.manualConvertProductTable = res.map((item) => ({
          ...item,
          SUPPLIER_ID: item.SUPPLIER_ID || '',
        }));
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    submitSecondConvert () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 11,
        ORDER_ID: Number(this.ORDER_ID),
        DETAIL_LIST: this.secondConvertProductTable,
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      http.post(params).then((res) => {
        if (!res.length) {
          this.secondConvertVisible = false;
          this.$message.show({ text: '二次转换成功', type: 'success' });
        } else {
          if (JSON.stringify(res) != '{}') {
            this.错误的产品列表 = res;
            this.已经转换产品模态框 = true;
          }
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // --------------------------手动转换确认按钮
    submitmanualConversion () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 11,
        ORDER_ID: Number(this.ORDER_ID),
        DETAIL_LIST: this.manualConvertProductTable,
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        CHANGE_STATUS: 0,
      };
      http.post(params).then((res) => {
        this.convertFormVisible = false;
        this.$message.show({ text: '手动转换成功', type: 'success' });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    checkPrice (value) {
      return validation.价格正数验证(value);
    },
    confirmWithNeedCount () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updateSendFun(params).then((res) => {
        this.updateOrderStatus();
      }).catch((error) => {
        this.$message.show({ text: '订单中有商品没有设置送货数量，无法以送货数量验收', type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    updateSend () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updateSendFun(params).then((result) => {
        this.$message.show({ text: '订单修改成功', type: 'success' });
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    // 批量修改送货数量
    batchUpdateSendCont () {
      this.$refs.tableForm.validate(async (valid) => {
        if (valid) {
          const paramsList = [];
          const resList = [];
          const erroeList = [];
          let flag = 0;
          this.tableForm.tableData.forEach((item, index) => {
            paramsList.push({
              SERVICE_ID: '10009',
              OTYPE: 48,
              DETAIL_ID: item.ORDER_DETAIL_ID,
              NEED_COUNT: Number(item.NEED_COUNT),
              TC_ID: Number(this.data[0].TC_ID),
            });
          });
          for (const item of paramsList) {
            try {
              const res = await http.post(item);
              resList.push(res);
            } catch (e) {
              erroeList.push(e);
            }
          }
          if (erroeList.length !== 0) {
            flag = 2;
          }
          if (flag == 0) {
            this.queryOrderDetailListData();
            this.$message.show({ text: '批量修改送货数量成功', type: 'success' });
          } else {
            let errText = '';
            let newArr = new Set(erroeList);
            newArr = Array.from(newArr);
            for (const item of newArr) {
              errText = `${item},${errText}`;
            }
            this.$message.show({ text: errText, type: 'error' });
            this.queryOrderDetailListData();
          }
        }
      });
    },
    updateOrder () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updateBookFun(params).then((result) => {
        this.$message.show({ text: '订单修改成功', type: 'success' });
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    // 全部确认
    __confirm () {
      this.$refs.tableForm.validate((valid) => {
        if (valid) {
          this.changeProducts = this.tableForm.tableData.filter((item) => item.NEW_REAL_COUNT !== item.REAL_COUNT || item.PRICE !== item.REAL_PRICE);
          if (this.changeProducts.length !== 0) {
            this.tableVisible = true;
          } else {
            this.subDataToServer();
          }
        }
      });
    },
    // --------------确认按钮
    subDataToServer () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.tableForm.tableData.map((item, index) => ({
            ORDER_DETAIL_ID: Number(item.ORDER_DETAIL_ID),
            PRODUCT_CODE: item.PRODUCT_CODE,
            NEW_COUNT: Number(item.NEW_REAL_COUNT),
            PRICE: Number(item.PRICE),
          }));
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('orderId')),
            PRODUCT_ARRAY: submitArr,
          };
          updateZLFun(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.tableVisible = false;
            this.updateOrderStatus();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    updateOrderStatus () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      confirmOrderFun(params).then((result) => {
        this.$message.show({ text: '订单确认成功', type: 'success' });
        this.$router.push({ name: 'supplierSendOrder' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit (row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.name = row.PRODUCT_NAME;
      this.ORDER_DETAIL_ID = row.ORDER_DETAIL_ID;
    },
    submitEdit () {
      if (this.$util.JudgmentUnit(this.editForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editForm.NEED_COUNT) : !validation.数量整数正数0验证(this.editForm.NEED_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'error' });
        return false;
      }
      const params = {
        DETAIL_ID: this.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editForm.NEED_COUNT),
        TC_ID: Number(sessionStorage.getItem('ORDER_TC_ID')),
      };
      this.loading = true;
      updateNewDetailFun_Limit(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editFormVisible = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
        this.queryOrderDetailListData();
      });
    },
    // 修改全部
    openAllEdit (row) {
      this.editAllFormVisible = true;
      this.editAllForm = row;
      this.Editname = row.PRODUCT_NAME;
    },
    countPrice () {
      if (validation.价格正数验证(this.editAllForm.BUY_PRICE)) {
        const params = {
          PRICE: this.editAllForm.BUY_PRICE,
          CATALOG_ID: this.editAllForm.CATALOG_ID,
        };
        priceCountFun(params).then((result) => {
          this.editAllForm.REAL_PRICE = result[0];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请输入正数的采购价', type: 'warning' });
        this.editAllForm.BUY_PRICE = '';
      }
    },
    // 全部提交
    submitEditAll () {
      if (!validation.数量正数0验证(this.editAllForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入数字', type: 'error' });
        return false;
      }
      if (!this.$util.JudgmentUnit(this.editAllForm.TYPE_UNIT)) { // 如果不是
        const beInter = (this.editAllForm.PRODUCT_COUNT % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
          return false;
        }
      }
      if (!validation.价格正数0验证(this.editAllForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_DETAIL_ID: this.editAllForm.ORDER_DETAIL_ID,
        NEW_COUNT: Number(this.editAllForm.PRODUCT_COUNT),
        MODIFY_FLAG: 1,
        PRICE: this.editAllForm.REAL_PRICE,
        PRODUCT_COMMENT: this.editAllForm.PRODUCT_COMMENT,
        SUPPLIER_ID: this.data[0].SUPPLIER_ID,
        PRODUCT_CODE: this.editAllForm.PRODUCT_CODE,
      };
      this.loading = true;
      updateOrderFun(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editAllFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeTable () {
      this.tableVisible = false;
      this.queryOrderDetailListData();
    },
    // 改变表格字体颜色
    tableRowClassName ({ row }) {
      if (Number(row.PRODUCT_COUNT) !== Number(row.REAL_COUNT)) {
        return 'warning-row';
      }
      return '';
    },
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
      sessionStorage.removeItem('TC_STATUS');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从转换订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        // 控制是否可以自行修改价格
        if (Number(that.CAN_MODIFY_PRICE) === 1) {
          that.isisdisabled = false;
        } else {
          that.isisdisabled = true;
        }
        that.queryOrderDetailListData();
        that.queryBeforeFun();
      }
    });
  },
  destroyed () {
    bus.$emit('submit', this.tableForm.tableData);
  },
};
</script>

<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

.buttonGroup {
  margin-top: 20px;
  flex: auto;
}

.buttonGroup .el-button {
  float: right;
  margin-right: 10px;
}

.el-table>>>.warning-row {
  color: rgb(245, 108, 108);
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/supplierSendOrderDetail.vue